var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 7.81974C7.33337 7.45155 7.63185 7.15308 8.00004 7.15308C8.36823 7.15308 8.66671 7.45155 8.66671 7.81974V11.8197C8.66671 12.1879 8.36823 12.4864 8.00004 12.4864C7.63185 12.4864 7.33337 12.1879 7.33337 11.8197V7.81974Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 4.53426C7.63185 4.53426 7.33337 4.83274 7.33337 5.20093C7.33337 5.56912 7.63185 5.86759 8.00004 5.86759C8.36823 5.86759 8.66671 5.56912 8.66671 5.20093C8.66671 4.83274 8.36823 4.53426 8.00004 4.53426Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 1.8335C4.31814 1.8335 1.33337 4.81826 1.33337 8.50016C1.33337 12.1821 4.31814 15.1668 8.00004 15.1668C11.6819 15.1668 14.6667 12.1821 14.6667 8.50016C14.6667 4.81826 11.6819 1.8335 8.00004 1.8335ZM2.66671 8.50016C2.66671 11.4457 5.05452 13.8335 8.00004 13.8335C10.9456 13.8335 13.3334 11.4457 13.3334 8.50016C13.3334 5.55464 10.9456 3.16683 8.00004 3.16683C5.05452 3.16683 2.66671 5.55464 2.66671 8.50016Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.aa6c4f0f1772fcb5e5089b37cc4ab013.svg";
export { ForwardRef as ReactComponent };